import styled from 'styled-components';
import FeatureSectionCard from 'components/ForCreatorSections/FeatureSectionCard';
import Text, { TypeVariant } from 'shared/Typography';
import { Title, TitleRow, Section } from '../Marketing/marketing.styles';

interface FeaturesData {
  label: string;
  value: string;
}

const data: FeaturesData[] = [
  {
    label: 'Individual Live Class Sessions',
    value:
      'Host single sessions for purchase or to include with membership access',
  },
  {
    label: 'One Time Special Events',
    value: 'Host a paid special event at any time',
  },
  {
    label: 'Programs',
    value: 'Create programs with videos, written guidance or downloadable docs',
  },
  {
    label: 'Challenges',
    value: 'Create challenges for your community to follow along',
  },
  {
    label: 'Recurring Subscriptions',
    value: 'Enable monthly and annual prices for full access to your site',
  },
  {
    label: 'Merchandise',
    value: 'Sell your merchandise through your site!',
  },
];

const RowSectionThree = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding: 0 20px;
  } ;
`;

const ContainerSecThree = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionFive = () => (
  <Section>
    <ContainerSecThree>
      <RowSectionThree style={{ maxWidth: '1100px', width: '100%' }}>
        <Title>
          <TitleRow>
            <Text
              variant={TypeVariant.header02}
              as="h2"
              tablet={TypeVariant.subtitle01}
              textAlign="center"
            >
              Ways to Earn
            </Text>
          </TitleRow>
        </Title>
        {data.map((val, i) => (
          <FeatureSectionCard
            key={i}
            label={val.label}
            value={val.value}
            bgColor="#101B3B"
            bgHover="black"
            perRow={3}
          />
        ))}
      </RowSectionThree>
    </ContainerSecThree>
  </Section>
);

export default SectionFive;
